export default "__VITE_ASSET__DF8VUrh2__"